import type { TabsDesignTokens } from '@primeuix/themes/types/tabs'

export default {
  tab: {
    gap: '0.5rem',
    color: '{text.muted.color}',
    margin: '0',
    padding: '1rem 1.25rem',
    focusRing: {
      color: '{focus.ring.color}',
      style: '{focus.ring.style}',
      width: '{focus.ring.width}',
      offset: '{focus.ring.offset}',
      shadow: 'inset {focus.ring.shadow}',
    },
    fontWeight: '700',
    hoverColor: '{text.color}',
    activeColor: '{primary.color}',
    borderColor: 'transparent',
    borderWidth: '2px 0 0 0',
    hoverBorderColor: 'transparent',
    activeBorderColor: '{primary.color}',
  },
  root: {
    transitionDuration: '{transition.duration}',
  },
  tablist: {
    background: '{content.background}',
    borderColor: '{content.border.color}',
    borderWidth: '0',
  },
  tabpanel: {
    color: '{content.color}',
    padding: '0.875rem 1.125rem 1.125rem 1.125rem',
    focusRing: {
      color: '{focus.ring.color}',
      style: '{focus.ring.style}',
      width: '{focus.ring.width}',
      offset: '{focus.ring.offset}',
      shadow: 'inset {focus.ring.shadow}',
    },
    background: '{content.background}',
  },
  activeBar: {
    bottom: '0',
    height: '0',
    background: 'transparent',
  },
  navButton: {
    color: '{text.muted.color}',
    width: '2.5rem',
    focusRing: {
      color: '{focus.ring.color}',
      style: '{focus.ring.style}',
      width: '{focus.ring.width}',
      offset: '{focus.ring.offset}',
      shadow: 'inset {focus.ring.shadow}',
    },
    background: '{content.background}',
    hoverColor: '{text.color}',
  },
  colorScheme: {
    dark: {
      tab: {
        background: '{surface.800}',
        hoverBackground: '{surface.700}',
        activeBackground: '{surface.900}',
      },
      navButton: {
        shadow:
          '0px 0px 10px 50px color-mix(in srgb, {content.background}, transparent 50%)',
      },
    },
    light: {
      tab: {
        background: '{surface.50}',
        hoverBackground: '{surface.100}',
        activeBackground: '{surface.0}',
      },
      navButton: {
        shadow: '0px 0px 10px 50px rgba(255, 255, 255, 0.6)',
      },
    },
  },
} satisfies TabsDesignTokens
